/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B100120 商品分類マスタメンテ
 */
import { Box } from "@mui/material";
import {
  B100120Create,
  B100120Delete,
  B100120ShohinchubunruiNm,
  B100120ShohinchubunruiNmShohinbunruiNm,
  B100120ShohindaibunruiNm,
  B100120ShohindaibunruiNmShohinbunruiNm,
  B100120ShohinshobunruiNm,
  B100120ShohinshobunruiNmShohinbunruiNm,
  B100120Update,
  catchRestError,
} from "clients/rest";
import {
  SCodeSelect,
  SFrame,
  SLabel,
  SNumberField,
  STextField,
  msgState,
  SNormalButton,
  SFileButton,
  SConfirmDialog,
  SCancelButton,
} from "components";
import { getClientError, getClientMessage } from "messages";
import {
  B100120Mode,
  B100120ShohinbunruiKbn,
  getSCode,
  SCode,
} from "messages/codes";
import { labels } from "messages/labels";
import { B000202 } from "pages/b000/B000202";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { focusState, useFocus } from "states";
import { B100910 } from "./B100910";

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  gamenId: string;
  shohinbunruiKbn: SCode;
  modeKbn: SCode;
  shodaibun: string;
  beforeShodaibun: string;
  shohindaibunruiNm: string;
  daiVersion: number;
  shochubun: string;
  beforeShochubun: string;
  shohinchubunruiNm: string;
  chuVersion: number;
  shoshobun: string;
  beforeShoshobun: string;
  shohinshobunruiNm: string;
  shoVersion: number;
  shohinbunruiNm: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  gamenId: "",
  shohinbunruiKbn: getSCode(B100120ShohinbunruiKbn, "0"),
  modeKbn: getSCode(B100120Mode, "0"),
  shodaibun: "",
  beforeShodaibun: "",
  shohindaibunruiNm: "",
  daiVersion: undefined,
  shochubun: "",
  beforeShochubun: "",
  shohinchubunruiNm: "",
  chuVersion: undefined,
  shoshobun: "",
  beforeShoshobun: "",
  shohinshobunruiNm: "",
  shoVersion: undefined,
  shohinbunruiNm: "",
};

// 固定値
// モード(新規)
const modeNew = "0";
// モード(修正)
const modeUpd = "1";
// モード(削除)
const modeDel = "2";

// 商品分類(大分類)
const shohindaibunrui = "0";
// 商品分類(中分類)
const shohinchubunrui = "1";
// 商品分類(小分類)
const shohinshobunrui = "2";

// 画面ID(大分類)
const gamenIdDai = "100120";
// 画面ID(中分類)
const gamenIdChu = "100121";
// 画面ID(小分類)
const gamenIdSho = "100122";

// フォーカスID
const focusId = "B100120";

// B100120 商品分類マスタメンテ
export const B100120 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 遷移元データ取得用
  const navigate = useNavigate();
  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // 活性設定
  // モード
  // 新規モードかどうか
  const isNew = methods.watch("modeKbn")?.value === modeNew;
  // 修正モードかどうか
  const isUpd = methods.watch("modeKbn")?.value === modeUpd;
  // 削除モードかどうか
  const isDel = methods.watch("modeKbn")?.value === modeDel;
  // 商品分類
  // 大分類かどうか
  const isDaibunrui =
    methods.watch("shohinbunruiKbn")?.value === shohindaibunrui;
  // 小分類かどうか
  const isShobunrui =
    methods.watch("shohinbunruiKbn")?.value === shohinshobunrui;

  // 初期表示イベント
  useEffect(() => {
    methods.setValue("gamenId", gamenIdDai);
    focus(1);
  }, []);

  // モード変更時
  const handleChangeModeKbn = () => {
    const fields = methods.getValues();
    // 新規の場合
    if (fields.modeKbn?.value === modeNew) {
      methods.setValue("shohindaibunruiNm", "");
      methods.setValue("shohinchubunruiNm", "");
      methods.setValue("shohinshobunruiNm", "");
      methods.setValue("shohinbunruiNm", "");
    }
    // 修正・削除の場合
    else {
      handleChangeShohinbunrui();
    }
  };

  // 商品分類変更時
  const handleChangeShohinbunrui = () => {
    const fields = methods.getValues();
    // 大分類が選択されている場合
    if (fields.shohinbunruiKbn?.value === shohindaibunrui) {
      // EXCEL出力画面のID設定
      methods.setValue("gamenId", gamenIdDai);
      handleShodaibun();
    }
    // 中分類が選択されている場合
    else if (fields.shohinbunruiKbn?.value === shohinchubunrui) {
      // EXCEL出力画面のID設定
      methods.setValue("gamenId", gamenIdChu);
      if (fields.modeKbn?.value !== modeNew) {
        B100120ShohindaibunruiNm(methods, navigate, setMsg);
      }
      handleShochubun();
    }
    // 小分類が選択されている場合
    else if (fields.shohinbunruiKbn?.value === shohinshobunrui) {
      // EXCEL出力画面のID設定
      methods.setValue("gamenId", gamenIdSho);
      if (fields.modeKbn?.value !== modeNew) {
        B100120ShohindaibunruiNm(methods, navigate, setMsg);
        B100120ShohinchubunruiNm(methods, navigate, setMsg);
      }
      handleShoshobun();
    }
  };

  // 商品大分類Blur時
  const shodaibunBlur = () => {
    // 変更されていない場合処理終了
    const fields = methods.getValues();
    if (fields.shodaibun === fields.beforeShodaibun) {
      return;
    }

    handleShodaibun();
  };
  // 商品大分類名取得処理
  const handleShodaibun = () => {
    const fields = methods.getValues();

    // 中分類をクリア
    methods.setValue("shochubun", "");
    methods.setValue("shohinchubunruiNm", "");
    methods.setValue("chuVersion", undefined);
    // 小分類をクリア
    methods.setValue("shoshobun", "");
    methods.setValue("shohinshobunruiNm", "");
    methods.setValue("shoVersion", undefined);

    // 大分類が選択されている場合かつモードが新規の場合
    if (
      fields.shohinbunruiKbn?.value === shohindaibunrui &&
      fields.modeKbn?.value === modeNew
    ) {
      return;
    }

    // 大分類が選択されている場合かつモードが修正・削除の場合
    if (
      fields.shohinbunruiKbn?.value === shohindaibunrui &&
      fields.modeKbn?.value !== modeNew
    ) {
      B100120ShohindaibunruiNmShohinbunruiNm(methods, navigate, setMsg);
    } else {
      B100120ShohindaibunruiNm(methods, navigate, setMsg);
    }

    // 変更の反映
    methods.setValue("beforeShodaibun", fields.shodaibun);
  };

  // 商品中分類Blur時
  const shochubunBlur = () => {
    // 変更されていない場合処理終了
    const fields = methods.getValues();
    if (fields.shochubun === fields.beforeShochubun) {
      return;
    }

    handleShochubun();
  };

  // 商品中分類名取得
  const handleShochubun = () => {
    const fields = methods.getValues();

    // 大分類が設定されていない場合エラー
    if (!methods.watch("shodaibun")) {
      setMsg(getClientError("B100120_001"));
      return;
    }

    // 小分類をクリア
    methods.setValue("shoshobun", "");
    methods.setValue("shohinshobunruiNm", "");
    methods.setValue("shoVersion", undefined);

    // 中分類が選択されている場合かつモードが新規の場合
    if (
      fields.shohinbunruiKbn?.value === shohinchubunrui &&
      fields.modeKbn?.value === modeNew
    ) {
      return;
    }

    // 中分類が選択されている場合かつモードが修正・削除の場合
    if (
      fields.shohinbunruiKbn?.value === shohinchubunrui &&
      fields.modeKbn?.value !== modeNew
    ) {
      B100120ShohinchubunruiNmShohinbunruiNm(methods, navigate, setMsg);
    } else {
      B100120ShohinchubunruiNm(methods, navigate, setMsg);
    }

    // 変更の反映
    methods.setValue("beforeShochubun", fields.shochubun);
  };

  // 商品小分類Blur時
  const shoshobunBlur = () => {
    // 変更されていない場合処理終了
    const fields = methods.getValues();
    if (fields.shoshobun === fields.beforeShoshobun) {
      return;
    }

    handleShoshobun();
  };

  // 商品小分類名取得処理
  const handleShoshobun = () => {
    const fields = methods.getValues();

    // 大分類/中分類いずれかが設定されていない場合エラー
    if (!methods.watch("shodaibun") || !methods.watch("shochubun")) {
      setMsg(getClientError("B100120_002"));
      return;
    }

    // 小分類が選択されている場合かつモードが新規の場合
    if (
      fields.shohinbunruiKbn?.value === shohinshobunrui &&
      fields.modeKbn?.value === modeNew
    ) {
      return;
    }

    // 小分類が選択されている場合かつモードが修正・削除の場合
    if (
      fields.shohinbunruiKbn?.value === shohinshobunrui &&
      fields.modeKbn?.value !== modeNew
    ) {
      B100120ShohinshobunruiNmShohinbunruiNm(methods, navigate, setMsg);
    } else {
      B100120ShohinshobunruiNm(methods, navigate, setMsg);
    }

    // 変更の反映
    methods.setValue("beforeShoshobun", fields.shoshobun);
  };

  // 商品分類照会ダイアログからの遷移時
  const handleSetData = (data: any) => {
    const fields = methods.getValues();

    // 商品大分類が選択されている場合
    if (fields.shohinbunruiKbn?.value === shohindaibunrui) {
      methods.setValue("shodaibun", data.shodaibun);
      (async () => {
        await B100120ShohindaibunruiNmShohinbunruiNm(methods, navigate, setMsg);
      })();
    }
    // 商品中分類が選択されている場合
    else if (fields.shohinbunruiKbn?.value === shohinchubunrui) {
      methods.setValue("shodaibun", data.shodaibun);
      methods.setValue("shochubun", data.shochubun);
      (async () => {
        await B100120ShohindaibunruiNm(methods, navigate, setMsg);
        await B100120ShohinchubunruiNmShohinbunruiNm(methods, navigate, setMsg);
      })();
    }
    // 商品小分類が選択されている場合
    else if (fields.shohinbunruiKbn?.value === shohinshobunrui) {
      methods.setValue("shodaibun", data.shodaibun);
      methods.setValue("shochubun", data.shochubun);
      methods.setValue("shoshobun", data.shoshobun);
      (async () => {
        await B100120ShohindaibunruiNm(methods, navigate, setMsg);
        await B100120ShohinchubunruiNm(methods, navigate, setMsg);
        await B100120ShohinshobunruiNmShohinbunruiNm(methods, navigate, setMsg);
      })();
    }
  };

  // 登録
  const handleClickCreateButton = () => {
    B100120Create(methods)
      .then(() => {
        // フィールドの初期化
        methods.reset();
        // ↓これがあると完了メッセージが表示される
        methods.setValue("shodaibun", "");
        // 登録完了メッセージ表示
        setMsg(getClientMessage("B100120_001"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 更新
  const handleClickUpdateButton = () => {
    B100120Update(methods)
      .then(() => {
        // フィールドの初期化
        methods.reset();
        // ↓これがあると完了メッセージが表示される
        methods.setValue("shodaibun", "");
        // 登録完了メッセージ表示
        setMsg(getClientMessage("B100120_002"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 削除
  const handleClickDeleteButton = () => {
    B100120Delete(methods)
      .then(() => {
        // フィールドの初期化
        methods.reset();
        // ↓これがあると完了メッセージが表示される
        methods.setValue("shodaibun", "");
        // 登録完了メッセージ表示
        setMsg(getClientMessage("B100120_003"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="商品分類マスタメンテ"
          gridTemplateColumns="9rem 5rem 4rem 11rem "
        >
          <Box />
          <SFileButton
            label={labels.buttons.excel}
            align="right"
            gridColumn="4"
            {...register(9)}
            dialog={<B100910 gamenId={methods.watch("gamenId")} />}
          />

          <SLabel required gridColumn="1">
            商品分類
          </SLabel>
          <SCodeSelect
            name="shohinbunruiKbn"
            label="商品分類"
            required
            options={B100120ShohinbunruiKbn}
            gridColumn="span 2"
            onChange={() => handleChangeShohinbunrui()}
            {...register(1)}
          />

          <SLabel required gridColumn="1">
            モード
          </SLabel>
          <SCodeSelect
            name="modeKbn"
            label="モード"
            required
            options={B100120Mode}
            gridColumn="span 2"
            onChange={() => handleChangeModeKbn()}
            {...register(2)}
          />

          <SLabel gridColumn="1">商品大分類コード</SLabel>
          {isNew ? (
            <>
              <SNumberField
                name="shodaibun"
                code
                size={3}
                onBlur={() => shodaibunBlur()}
                {...register(3)}
              />
            </>
          ) : (
            <>
              <SNumberField
                name="shodaibun"
                code
                size={3}
                onBlur={() => shodaibunBlur()}
                dialog={<B000202 />}
                handleSubmit={(data: any) => {
                  handleSetData(data);
                }}
                {...register(3)}
              />
            </>
          )}
          <STextField name="shohindaibunruiNm" disabled gridColumn="span 2" />

          <SLabel gridColumn="1">商品中分類コード</SLabel>
          {isNew ? (
            <>
              <SNumberField
                name="shochubun"
                code
                size={3}
                disabled={isDaibunrui}
                onBlur={() => shochubunBlur()}
                {...register(4)}
              />
            </>
          ) : (
            <>
              <SNumberField
                name="shochubun"
                code
                size={3}
                disabled={isDaibunrui}
                onBlur={() => shochubunBlur()}
                dialog={<B000202 />}
                handleSubmit={(data: any) => {
                  handleSetData(data);
                }}
                {...register(4)}
              />
            </>
          )}
          <STextField name="shohinchubunruiNm" disabled gridColumn="span 2" />

          <SLabel gridColumn="1">商品小分類コード</SLabel>
          {isNew ? (
            <>
              <SNumberField
                name="shoshobun"
                code
                size={3}
                disabled={!isShobunrui}
                onBlur={() => shoshobunBlur()}
                {...register(5)}
              />
            </>
          ) : (
            <>
              <SNumberField
                name="shoshobun"
                code
                size={3}
                disabled={!isShobunrui}
                onBlur={() => shoshobunBlur()}
                dialog={<B000202 />}
                handleSubmit={(data: any) => {
                  handleSetData(data);
                }}
                {...register(5)}
              />
            </>
          )}
          <STextField name="shohinshobunruiNm" disabled gridColumn="span 2" />
        </SFrame>

        <SFrame gridTemplateColumns="9rem 20rem ">
          <SLabel gridColumn="1">商品分類名</SLabel>
          {isDel ? (
            <>
              <STextField
                name="shohinbunruiNm"
                size={20}
                disabled
                {...register(6)}
              />
            </>
          ) : (
            <>
              <STextField name="shohinbunruiNm" size={20} {...register(6)} />
            </>
          )}

          <Box />

          {isNew ? (
            <>
              <SNormalButton
                label={labels.buttons.create}
                align="right"
                {...register(7)}
                dialog={
                  <SConfirmDialog
                    title={labels.dialog.createMasterTitle}
                    msg={labels.dialog.createConfirm}
                  />
                }
                dialogAction="confirm"
                handleSubmit={handleClickCreateButton}
              />
            </>
          ) : (
            <>
              {isUpd ? (
                <>
                  <SNormalButton
                    label={labels.buttons.update}
                    align="right"
                    {...register(7)}
                    dialog={
                      <SConfirmDialog
                        title={labels.dialog.updateMasterTitle}
                        msg={labels.dialog.updateConfirm}
                      />
                    }
                    dialogAction="confirm"
                    handleSubmit={handleClickUpdateButton}
                  />
                </>
              ) : (
                <>
                  <SCancelButton
                    label={labels.buttons.delete}
                    align="right"
                    {...register(7)}
                    dialog={
                      <SConfirmDialog
                        title={labels.dialog.deleteMasterTitle}
                        msg={labels.dialog.deleteConfirm}
                      />
                    }
                    dialogAction="confirm"
                    handleSubmit={handleClickDeleteButton}
                  />
                </>
              )}
            </>
          )}
        </SFrame>
      </FormProvider>
    </>
  );
};
